export const START_WORK_SESSION = "START_WORK_SESSION";
export const END_WORK_SESSION = "END_WORK_SESSION";
export const SET_WORK_SESSION_INDEX = "SET_WORK_SESSION_INDEX";
export const NEXT_WORK_SESSION_TASK = "NEXT_WORK_SESSION_TASK";
export const PREV_WORK_SESSION_TASK = "PREV_WORK_SESSION_TASK";
export const SET_WORK_SESSION_TASK_HANDLED = "SET_WORK_SESSION_TASK_HANDLED";
export const UPDATE_WORK_SESSION_TASK = "UPDATE_WORK_SESSION_TASK";
export const OPEN_WORK_SESSION_MODAL = "OPEN_WORK_SESSION_MODAL";
export const CLOSE_WORK_SESSION_MODAL = "CLOSE_WORK_SESSION_MODAL";
